import React from 'react'
import styled, { css } from 'styled-components'

import { useArtboardContext } from 'modules/shares/DetailView/ArtboardContext'

const Grid = styled.div<{ gridSize: number; bolder?: boolean }>(
  ({ gridSize, bolder }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    pointer-events: none;

    background-image: repeating-linear-gradient(
        rgba(254, 26, 24, ${bolder ? 0.6 : 0.3}) 0 1px,
        transparent 1px 100%
      ),
      repeating-linear-gradient(
        90deg,
        rgba(254, 26, 24, ${bolder ? 0.6 : 0.3}) 0 1px,
        transparent 1px 100%
      );
    background-size: ${gridSize}px ${gridSize}px;
  `
)

//
export const OverlayGrid = () => {
  const {
    isGridEnabled,
    zoomFactor,
    gridSize,
    thickGridTimes,
    isInspectorEnabled,
  } = useArtboardContext()

  if (!isGridEnabled || !isInspectorEnabled) {
    return null
  }

  const gridSizeAfterZoom = gridSize * zoomFactor

  return (
    <>
      <Grid gridSize={gridSizeAfterZoom * thickGridTimes} bolder />
      <Grid gridSize={gridSizeAfterZoom} />
    </>
  )
}
